// Centralized token service for legacy and iOS-tokenizer flows

interface TokenizerGetTokenResponse {
  token_type: string;
  expires_in: number;
  ext_expires_in: number;
  access_token: string;
}

export async function fetchTokenizerToken(sid: string, url: string): Promise<string> {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sid }),
  });
  if (!res.ok) throw new Error('Failed to fetch tokenizer token');
  const data: TokenizerGetTokenResponse = await res.json();
  return data.access_token;
}